"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoanMetricsParams = void 0;
const createLoanMetricsParams = () => {
    // currently no params required. can extend as needed.
    return {
        isValid: true,
        params: null,
    };
};
exports.createLoanMetricsParams = createLoanMetricsParams;
//# sourceMappingURL=loanMetricsParams.js.map